/* component to embed a form directly in the page */

import ReactDOM from "react-dom";
import React, { useState, useEffect } from "react";
import "./embeddedFormModal.css";
import PopUpSuccessMessageModal from "../formSubmissionSuccessMessageModal/popUpSuccessMessageModal";

const EmbeddedFormModal = ({ children }) => {
  const [showSuccessFormMessage, setShowSuccessFormMessage] = useState(false);
  const [successForm, setSuccessForm] = useState("");

  const handleSuccess = (formSubmitted) => {
    setSuccessForm(formSubmitted);
    setShowSuccessFormMessage(true);
    if (
      formSubmitted === "download" ||
      formSubmitted === "scorecard-download"
    ) {
      const link = document.createElement("a");
      link.href =
        "/assets/content/CommunityWildfireResilienceScorecard-02-20-24v03b.zip";
      link.download = "CommunityWildfireResilienceScorecard-02-20-24v03b.zip";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const handleError = () => {
    setSuccessForm("error");
    setShowSuccessFormMessage(true);
  };

  return (
    <>
      {/*
      {activeForm === "contact" && (
        <FormContact
          onSuccess={handleFormSubmissionSuccessMessage}
          onError={handleFormSubmissionErrorMessage}
        />
      )}

      {activeForm === "subscribe" && (
        <PopUpFormSubscribe
          onSuccess={handleFormSubmissionSuccessMessage}
          onError={handleFormSubmissionErrorMessage}
        />
      )}

      {activeForm === "scorecard-subscribe" && (
        <PopUpScorecardFormSubscribe
          onSuccess={handleFormSubmissionSuccessMessage}
          onError={handleFormSubmissionErrorMessage}
        />
      )}

      {activeForm === "scorecard-subscribe-long" && (
        <FormScorecardSubscribeLong
          onSuccess={handleFormSubmissionSuccessMessage}
          onError={handleFormSubmissionErrorMessage}
        />
      )}
    */}

      <div className="embedded-form">
        <>
          {React.cloneElement(children, {
            onSuccess: handleSuccess,
            onError: handleError,
          })}
        </>
      </div>

      {showSuccessFormMessage && (
        <>
          <PopUpSuccessMessageModal
            successForm={successForm}
            showSuccessFormMessage={showSuccessFormMessage}
            setShowSuccessFormMessage={setShowSuccessFormMessage}
          />
        </>
      )}
    </>
  );
};

export default EmbeddedFormModal;
